module.exports = __webpack_public_path__ + "img/nav_flex_selected.0ff95c18.svg";